// client/src/services/userProductLicenseService.js
import { api } from "./api";

class UserProductLicenseService {
  // Generate a license for a user-product (admin only)
  async generateLicense(userId, productId, licenseData) {
    try {
      const response = await api.post(
        `/licenses/users/${userId}/products/${productId}/license`,
        licenseData
      );
      return response.data;
    } catch (error) {
      console.error("Error generating license:", error);
      throw error.response?.data || error;
    }
  }

  // Get license history for a user-product (admin only)
  async getLicenseHistory(userId, productId) {
    try {
      const response = await api.get(
        `/licenses/users/${userId}/products/${productId}/licenses`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching license history:", error);
      throw error.response?.data || error;
    }
  }

  // Get current license for a user-product (admin or user for their own licenses)
  async getCurrentLicense(userId, productId) {
    try {
      const response = await api.get(
        `/licenses/users/${userId}/products/${productId}/license/current`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching current license:", error);
      throw error.response?.data || error;
    }
  }

  // Get all licenses for the current user
  async getMyLicenses() {
    try {
      const response = await api.get("/licenses/my-licenses");
      return response.data;
    } catch (error) {
      console.error("Error fetching my licenses:", error);
      throw error.response?.data || error;
    }
  }

  // Get current license for a specific product for the current user
  async getMyProductLicense(productId) {
    try {
      const response = await api.get(
        `/licenses/my-products/${productId}/license`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching my product license:", error);
      throw error.response?.data || error;
    }
  }
}

export const userProductLicenseService = new UserProductLicenseService();
